var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('router-link',{attrs:{"to":"/quiz"}},[_c('img',{attrs:{"src":require("../../assets/strangert.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }